module.exports = __webpack_public_path__ + "img/ico-ders-notu-ata.e2d10aad.svg";